import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledModalWrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	z-index: 5;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.98);
	opacity: 0;
	transition: opacity 0.3s ease;

	&.modal-enter {
		opacity: 0;
	}

	&.modal-enter-active,
	&.modal-enter-done,
	&.modal-exit {
		opacity: 1;
	}

	&.modal-exit-active {
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 600px;
	max-height: 100%;
	padding-top: 100px;
`;

const StyledTopContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-shrink: 0;
	margin-bottom: 30px;

	${Text} {
		font-weight: 500;
		font-size: 20px;
		color: #ffffff;
	}
`;

const StyledDivider = styled.div`
	width: 100%;
	height: 1px;
	background-color: rgba(255, 255, 255, 0.1);
	flex-shrink: 0;
	margin-bottom: 30px;
`;

const StyledTextContainer = styled.div`
	overflow-y: auto;
	padding-bottom: 80px;

	&::-webkit-scrollbar {
		display: none;
	}

	${Text} {
		font-weight: 400;
		font-size: 16px;
		color: rgba(255, 255, 255, 0.5);
	}
`;

export {
	StyledContainer,
	StyledDivider,
	StyledModalWrapper,
	StyledTextContainer,
	StyledTopContainer,
};
